import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ReferralContact } from '../models/referral-contacts';
import { DataService } from './data.service';

@Injectable({
    providedIn: 'root'
})
export class ReferralNotificationService {

    constructor(private dataService: DataService) { }

    getReferredContacts() {
        var accessToken = sessionStorage.getItem(environment.ACCESS_TOKEN_KEY);
        var baseUrl = sessionStorage.getItem(environment.API_ENDPOINT);

        return this.dataService.get<ReferralContact[]>(`api/ReferralNotifications/referred-contacts?userAccessToken=${accessToken}&baseUrl=${baseUrl}`);
    }
}
